import { render, staticRenderFns } from "./PageRole.vue?vue&type=template&id=7e56866a&"
import script from "./PageRole.vue?vue&type=script&lang=js&"
export * from "./PageRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e56866a')) {
      api.createRecord('7e56866a', component.options)
    } else {
      api.reload('7e56866a', component.options)
    }
    module.hot.accept("./PageRole.vue?vue&type=template&id=7e56866a&", function () {
      api.rerender('7e56866a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/role/PageRole.vue"
export default component.exports